import { FiatIcon } from 'BreetAssets';
import { CURRENCYCONFIG } from 'BreetHelpers';

import type { ICurrencyDropdownItemOptions } from '../../Dropdown.helpers';

const CurrencyItemOptions = ({ items, handleItemSelection, CustomItemOption }: ICurrencyDropdownItemOptions) => (
	<>
		{items.map((item) => (
			<button
				key={`${item.currency}_${item.walletBalance}`}
				onClick={handleItemSelection(item)}
				className='dropdown_content_item_options_item currency'
				data-testid={`currency-button-${item.currency}`}
				title={item.currency}
				name={item.currency}
			>
				{!CustomItemOption ? (
					<>
						<span className='dropdown_content_item_options_item_name color-primary-50'>
							{CURRENCYCONFIG[item.currency].symbol}&nbsp;
							{item.walletBalance}
						</span>

						<span className='dropdown_content_item_options_item_flag'>
							<FiatIcon
								currencyCode={item.currency}
								variant='round'
							/>
						</span>
					</>
				) : (
					<CustomItemOption item={item} />
				)}
			</button>
		))}
	</>
);

export default CurrencyItemOptions;
